import { StyleSheet } from 'aphrodite';
import { titles, borderColor, background, error, brandPrimary } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	dialogPopup: {
		maxWidth: 600,
		width: '100%',
		maxHeight: '85vh',
		overflowY: 'auto',
	},

	setupSection: {
		marginBottom: 24,
	},

	pitchTypeSection: {
		marginBottom: 16,
	},

	providerSection: {
		marginBottom: 16,
	},

	label: {
		display: 'block',
		fontSize: 14,
		fontWeight: 500,
		color: titles,
		marginBottom: 8,
	},

	select: {
		width: '100%',
		padding: '8px 12px',
		fontSize: 14,
		border: `1px solid ${borderColor}`,
		borderRadius: 4,
		backgroundColor: background,
		color: titles,
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
			boxShadow: `0 0 0 2px ${brandPrimary}33`,
		},
	},

	error: {
		padding: 12,
		marginBottom: 16,
		backgroundColor: `${error}22`,
		border: `1px solid ${error}`,
		borderRadius: 4,
		color: error,
		fontSize: 14,
	},

	buttonSection: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: 24,
	},

	connectButton: {
		minWidth: 160,
	},
});
